'use client';

import { useEffect, useState } from 'react';

/**
 * ScrollTopButton component - React implementation of Silicon's scroll-top-button
 * Shows a button to scroll back to the top when the user has scrolled down
 */
const ScrollTopButton = ({ scrollOffset = 600 }) => {
  const [visible, setVisible] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > scrollOffset) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };
    
    // Add event listener for scroll
    window.addEventListener('scroll', handleScroll);
    
    // Initial check in case page is loaded scrolled down
    handleScroll();
    
    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrollOffset]);
  
  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  
  return (
    <a 
      href="#top" 
      className={`btn-scroll-top ${visible ? 'show' : ''}`}
      onClick={scrollToTop}
      aria-label="Scroll to top"
    >
      <span className="btn-scroll-top-tooltip text-muted fs-sm me-2">Top</span>
      <i className="btn-scroll-top-icon bx bx-chevron-up"></i>
    </a>
  );
};

export default ScrollTopButton; 